"use client";

import { ReactNode } from "react";
import { usePathname } from "next/navigation";
import Box from "@mui/material/Box";
import PartnerProgramCapture from "./PartnerProgramCapture";

type ClientLayoutProps = {
  children: ReactNode;
};

const ClientLayout = ({ children }: ClientLayoutProps) => {
  const pathname = usePathname();

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr)",
        gridTemplateRows: "auto 1fr auto", // Header, content, footer
        minHeight: "100vh",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        backgroundColor: pathname.startsWith("/auth/sign")
          ? "black"
          : "background.default",
        // Prevent a wide content row from expanding the grid track (and the navbar).
        "& > *": {
          minWidth: 0,
          maxWidth: "100%",
        },
      }}
    >
      <PartnerProgramCapture />
      {children}
    </Box>
  );
};

export default ClientLayout;
